var exports = {
  "jy": "AnimationTab.module__radioSection___OVdlRn",
  "lm": "AnimationTab.module__radioHeader___OVdlRn",
  "et": "AnimationTab.module__radioLabel___OVdlRn",
  "Ye": "AnimationTab.module__radioDescription___OVdlRn",
  "X0": "AnimationTab.module__reducedMotionNote___OVdlRn",
};

module.exports = exports;
